export default __webpack_public_path__ + "static/media/mc_openlid_icon.906af17b.svg";